import Link from "next/link";
import React, { useState } from "react";
import MobileOtp from "../hero/hero-rslhome/MobileOtp";
import { signUp, verifyPhone } from "../../redux/slices/product";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSession, signIn, signOut } from "next-auth/react";
import { getProfile, getAccessToken } from '../../redux/slices/user';
import { Typography } from "@mui/material";

const SignUp = ({ setOpenReg, setPrintMsg, setIsSignUp, viewStatus, setViewStatus, printMsg }) => {
  const { data: session, status, user, customuser } = useSession();
  // Sign Up Api
  const router = useRouter();
  const getLatestPath = sessionStorage.getItem("bookingPath");
  const { userId } = router.query;
  const dispatch = useDispatch();
  const { signUpData, verifyPhoneData } = useSelector((state) => state.product);

  const [signUpVal, setSignUpVal] = useState({});

  const handleVehicleDetails = (e) => {
    setPrintMsg("");
    const { name, value } = e.target;
    setSignUpVal({ ...signUpVal, [name]: value });
  };




  const handleSignUp = async (event) => {
    event.preventDefault(); // Prevent form submission

    // Helper function to check email validity
    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Standard email pattern
      return emailRegex.test(email);
    };

    // Check if name and email are valid
    if (!signUpVal.name || signUpVal.name.trim().length < 2) {
      setPrintMsg("Name must be at least 2 characters long");
      return null; // Stop execution if name is invalid
    }

    if (!isValidEmail(signUpVal.email)) {
      setPrintMsg("Invalid email format");
      return null; // Stop execution if email is invalid
    }

    const getCookie = (name) => {
      const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${name}=`));


      if (cookieValue) {
        return cookieValue.split('=')[1];
      }

      return null;
    };

    // Usage
    const apiToken = getCookie('apiToken');
    // const obj = {
    //   userId: JSON.parse(sessionStorage.getItem("rslkey")),
    //   countryCode: JSON.parse(sessionStorage.getItem("countryCode")),
    //   mobile: JSON.parse(sessionStorage.getItem("phone")),
    //   name: signUpVal.name,
    //   email: signUpVal.email,
    //   role: 1,
    // };
    // dispatch(signUp(obj));
    event.preventDefault();

    const response = await signIn("credentials", {
      loginType: "verifysignup",
      userId: session?.customuser?.responseData?.userId,
      name: signUpVal.name,
      email: signUpVal.email,
      role: 1,
      redirect: false, // Disable automatic redirect
      refTocken: session?.customuser?.accessToken ? session?.customuser?.accessToken : apiToken,
    }).then((res) => {


      if (res.ok) {
        // setViewStatus(true);
        // setOpenReg(false);
        // setIsSignUp(false)

      } else {
        dispatch(getAccessToken({}))
      }
      // setVerifyPhoneResponse(res);
    });

    // if (signUpData?.status === 1) {
    //   if (getLatestPath !== "" && getLatestPath !== null) {
    //     // router.push(getLatestPath);
    //     sessionStorage.setItem("isSig", "");
    //     setOpenReg(false);
    //     return false;
    //   } else {
    //     // router.push("/");
    //     setOpenReg(false);
    //     setIsSignUp(false);
    //     sessionStorage.setItem("isSig", "");
    //   }
    // }
  };




  return (
    <>
      <form className="sign-up-form ">
        <div className="sign-in-header col-12  flex-column d-flex text-center">
          {/* <h2>
            Hello <span className="header-span">Sign Up Here!</span>
          </h2> */}
          <div className="d-flex flex-column gap-4 justify-center">
            <input
              className="sign-up-input"
              type="text"
              placeholder="Enter Your Name"
              name="name"
              value={signUpVal.name}
              onChange={handleVehicleDetails}
            />
            <input
              className="sign-up-input"
              type="email"
              placeholder="Email"
              name="email"
              value={signUpVal.email}
              onChange={handleVehicleDetails}
            />
            {/* <div>
              <MobileOtp
                setPhoneNo={setPhoneNo}
                setCountryCode={setCountryCode}
              />
            </div> */}
          </div>


          <div className="col-12 text-center mt-40"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: 'center',
              gap: "10px"
            }}>
            <Typography
              variant="body2"
              style={{
                textAlign: 'start',
                color: 'red',
              }}
            >
              {printMsg}
            </Typography>
            <button
              className="btn-1 text-white"
              style={{
                width: "200px",
                height: "50px",
                borderRadius: "9px",
              }}
              onClick={handleSignUp}
            >
              {/* <Link href="#">Sign In</Link>
               */}
              sign Up
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default SignUp;
